module.exports = {
	router: {
		mode: 'history',
	},
	'cors.origin': ['http://localhost:8080'],
};
